import script from "./background.vue?vue&type=script&setup=true&lang=ts"
export * from "./background.vue?vue&type=script&setup=true&lang=ts"

import "./background.vue?vue&type=style&index=0&id=2cc0c4b1&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Projects/IceCreamSearch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc0c4b1"]])

export default __exports__